import { FC } from "react";
import WorkspaceSettingsPage from "@web-src/modules/workspace/pages/WorkspaceSettingsPage";
import { CXWorkspaceSettingsLayout } from "../CXWorkspaceSettingsLayout";

export const CXWorkspaceGeneralPage: FC = () => (
  <CXWorkspaceSettingsLayout>
    <WorkspaceSettingsPage useDefaultLayout={false} />
  </CXWorkspaceSettingsLayout>
);
